export default __webpack_public_path__ + "static/Results-oriented-15523fe2bf3f7efc434452c314ef0f9a.webp";